import { useEffect, useState } from 'react';
import { styled } from '@linaria/react';
import { DesktopHeader, MobileHeader } from '../Header';
import useAuth from '../../contexts/auth';
import { isSSR } from '../../utils/helpers';
import { useBreakpoint } from '@spaceshipapp/cambridge';
import hubspot from '../../utils/hubspot';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [{ authenticated, user, hubspotToken }, auth] = useAuth();
  const { breakpoint } = useBreakpoint('mobile');
  const [isResumed, setIsResumed] = useState(false);
  const header: Record<string, JSX.Element> = {
    mobile: <MobileHeader />,
    tablet: <DesktopHeader />,
    desktop: <DesktopHeader />,
  };

  useEffect(() => {
    const resumeSession = async () => {
      await auth.resumeSession();
      setIsResumed(true);
    };
    resumeSession();
  }, []);

  useEffect(() => {
    if (authenticated && user && hubspotToken) {
      hubspot.setVisitorId(user.email, hubspotToken);
    } else {
      hubspot.clearVisitorId();
    }
  }, [authenticated, hubspotToken]);

  if (!isSSR && !isResumed) return null;

  return (
    <Container>
      {breakpoint && header[breakpoint]}
      {children}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: -webkit-fill-available;
`;

export default Layout;
